module.exports = __webpack_public_path__ + "img/formsHeptagon.c1471837.svg";